import React, { useEffect, useState } from "react";
import {
  Container,
  SearchContainer,
  SearchInput,
  SearchIcon,
  CleanSearchIcon,
  Pagination,
  Grid,
  Column,
  Button,
} from "./styles";
import { Select } from "semantic-ui-react";
import CursosSelector from "../../../../components/Admin/CursosSelector";

const Controls = (props) => {
  const handleNomePessoa = (e, { value }) => {
    props.setNomePessoa(value);
  };

  const handleIdPedido = (e, { value }) => {
    props.setIdPedido(value);
  };

  return (
    <Container reverse={props.reverse}>
      <Grid columns={4}>
        <Column padding="0 8px 0 0">
          <SearchContainer>
            <SearchInput
              fluid
              placeholder="Nome do aluno"
              onChange={handleNomePessoa}
              onKeyPress={(e) => e.key == "Enter" && props?.doSearchNomePessoa()}
              value={props.nomePessoa}
            />

            {props.nomePessoa ? (
              <SearchIcon size={22} onClick={props?.doSearchNomePessoa} />
            ) : (
              <CleanSearchIcon
                size={22}
                onClick={props.cleanSearchNomePessoa}
              />
            )}
          </SearchContainer>
        </Column>
        <Column padding="0 8px 0 0">
          <SearchContainer>
            <SearchInput
              fluid
              placeholder="ID Pedido"
              onChange={handleIdPedido}
              onKeyPress={(e) => e.key == "Enter" && props.doSearchIdPedido()}
              value={props.idPedido}
            />

            {props.idPedido ? (
              <SearchIcon size={22} onClick={props.doSearchIdPedido} />
            ) : (
              <CleanSearchIcon size={22} onClick={props.cleanSearchIdPedido} />
            )}
          </SearchContainer>
        </Column>
        <Column padding="0 0 16px 0">
          <CursosSelector
            handleChange={(value) => {
              props.setIdCurso(value);
            }}
          />
        </Column>
        <Column horizontal padding="0 0 0 24px">
          <Button
            onClick={() => window.open("/admin/relatorios/subitens?item=1")}
          >
            Materiais
          </Button>
          <Button
            onClick={() => window.open("/admin/relatorios/subitens?item=2")}
          >
            Certificados
          </Button>
        </Column>
      </Grid>

      <Pagination
        page={props.page}
        onChange={props.handlePageChange}
        count={props.pages}
        shape="rounded"
      />
    </Container>
  );
};

export default Controls;
